/* eslint-disable import/prefer-default-export */
export const cid = [
    { value: 'Ansiedade', label: 'F41.2' },
    { value: 'Arritmia Ventricular', label: 'I47.0' },
    { value: 'Avaliação geral de rotina', label: 'Z00.0' },
    { value: 'Comunicação Interventricular', label: 'Q21.0' },
    { value: 'Comunicação Interatrial', label: 'Q21.1' },
    { value: 'Depressão', label: 'F32' },
    { value: 'Diabetes Mellitus tipo II', label: 'E11' },
    { value: 'Dispneia', label: 'R06.0' },
    { value: 'Dislipidemia', label: 'E78.2' },
    { value: 'Doença Arterial Coronariana', label: 'I25' },
    { value: 'Doença Pulmonar Obstrutiva Crônica', label: 'J44' },
    { value: 'Doença Reumatica da Valva Aórtica', label: 'I06' },
    { value: 'Doença Reumatica da Valva Mitral', label: 'I05' },
    { value: 'Doença de Chagas', label: 'B57.2' },
    { value: 'Dor Precordial', label: 'R07.2' },
    { value: 'Estenose Valvar Pulmonar', label: 'Q22.1' },
    { value: 'Fibrilação Atrial', label: 'I48' },
    { value: 'Hipertensão Arterial Sistêmica', label: 'I10' },
    { value: 'Insuficiência Cardiaca Congestiva', label: 'I50.0' },
    { value: 'Marcapasso cardíaco', label: 'Z95.0' },
    { value: 'Obesidade', label: 'E66.8' },
    { value: 'Palpitações', label: 'R00.2' },
    { value: 'Prolapso da Valva Mitral', label: 'I34.1' },
    { value: 'Prótese Valvar', label: 'Z95.2' },
    { value: 'Sincope', label: 'R55' },
    { value: 'Taquicardia Paroxistica Supraventricular', label: 'I47.1' },
    { value: 'Valva Aórtica Bicúspide', label: 'Q23.1' },
];